import React, { ChangeEvent } from 'react';
import { CustomInput, UncontrolledTooltip } from 'reactstrap';
import { BsQuestionCircle } from 'react-icons/bs';

interface PermanentInputProps {
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export const PermanentInput = ({ checked, onChange, disabled }: PermanentInputProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <CustomInput type="switch" id="permanentSwitch" name="permanent" label="Mark as Permanent" checked={checked} onChange={onChange} disabled={disabled} />
      <span
        id="permanentHelp"
        tabIndex={0}
        role="button"
        aria-label="Help information about permanent documents"
        style={{ cursor: 'pointer', color: '#6c757d', display: 'inline-flex', alignItems: 'center' }}
      >
        <BsQuestionCircle size={16} />
      </span>
      <UncontrolledTooltip placement="right" target="permanentHelp">
        Permanent documents are excluded from retention policies and cannot be deleted via bulk operations
      </UncontrolledTooltip>
    </div>
  );
};
